module.exports = __webpack_public_path__ + "img/timmy-04.b7c89282.png";